var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b7e2f76a974c6caa07100a339fbaac3899c3dbe8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["brands-app@get-it-done-tech-gmbh"]={id:"b7e2f76a974c6caa07100a339fbaac3899c3dbe8"};
      